import * as React from 'react';
export const discernSvg = React.forwardRef(function discernSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M19.517 2.043c-.017.03-.033.287-.037.575-.038 3.562-5.201 3.539-7.929-.036-.639-.837-.675-.424-.058.658.742 1.302 1.679 2.121 3.877 3.392 1.463.846 1.956 1.851 1.591 3.24-.135.516-.073.548.393.2 1.946-1.455 2.987-4.157 2.624-6.81-.115-.84-.339-1.43-.462-1.219ZM9.78 7.21c-4.903 8.705.862 20.46 10.656 21.726.98.127 1.14.076.662-.21-6.06-3.624-9.062-11.23-6.345-16.072.25-.444.242-.478-.116-.48-2.634-.01-4.285-1.754-4.404-4.649-.039-.95-.08-.978-.453-.315Zm4.043.031c-.745.47-.872 1.334-.285 1.947.99 1.038 2.62-.329 1.832-1.538-.313-.48-1.104-.688-1.547-.409Zm3.878 4.063C11.482 13.005 15.04 25.55 22.6 28.577l.318.127.214-.34c1.75-2.782 2.34-7.012 1.469-10.508-1.05-4.21-4.273-7.271-6.9-6.552Z',
      fill: '#000',
    }),
  );
});
discernSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var discern = {
  category: 'brand',
  colorable: false,
  name: 'discern',
  svg: discernSvg,
};
